// types
import { FieldTransform } from '../../../index'
// graphql
import { USERS_LIST_QUERY } from 'graphql/user/queries'
// utils
import moment from 'moment'

export const fieldMap: Partial<Record<string, string | FieldTransform>> = {
  'd6957cc0-b2e0-40c2-a1eb-3b027cc8eff6': 'program',
  '687dccf6-cb08-4502-bbce-100f40920eb8': 'location',
  'ba96faa3-8b30-4038-b9a1-0cd4110108bc': (value) => ({
    date: value ? moment(value).format('DD.MM.YYYY') : '',
    time: value ? moment(value).format('HH:mm') : ''
  }),
  '60344735-9ff1-454e-a7be-5fb9efab049e': (value) => ({
    clientName: value?.label ?? '',
    _clientUserId: value?.value ?? null
  }),
  'e92170ee-b632-4594-8e37-a33f938ae7f8': (value) => ({
    isCritical: value?.label === 'Critical',
    isNonCritical: value?.label === 'Non-Critical'
  }),
  '3dd05a4c-18ac-47ce-aae2-37734e81d5bc': 'details',
  '6a074ce7-8611-42cc-b898-60038484b51d': 'actionTaken',
  '55f6427c-95ea-4051-a16c-ba3a7ed36028': (value) => ({
    employeeName: value?.label ?? '',
    employeeSignature: value?.label ?? ''
  }),
  'ee55da5b-adfb-4768-ac0d-d99f8ef3d1ed': 'employeePosition',
  '2563b16c-13ed-42d5-bcc7-ffc75916a7da': (value) => ({
    employeeDate: value ? moment(value).format('DD.MM.YYYY HH:mm') : ''
  }),
  '95fde9dc-a5e1-495c-bdf2-a1b92b74a9ce': (value) => ({
    managerName: value?.label ?? '',
    managerSignature: value?.label ?? ''
  }),
  '87a4ea0f-5616-4fac-ac31-bad4f90b1d5a': 'managerPosition',
  'e7afd5db-8c23-4890-ab02-636ab7ee153b': (value) => ({
    managerDate: value ? moment(value).format('DD.MM.YYYY HH:mm') : ''
  })
}

export const resolveAsync = async (
  values: Record<string, unknown>,
  apolloClient: any
): Promise<Record<string, unknown>> => {
  const userId = values._clientUserId as string

  if (!userId) {
    return {}
  }

  const { data } = await apolloClient.query({
    query: USERS_LIST_QUERY,
    variables: { filter: { id: userId } }
  })

  const user = data?.settingsUsers?.data?.[0]

  return { clientDob: user?.dateOfBirth ? moment(user.dateOfBirth).format('DD/MM/YYYY') : '' }
}
